<template>
  <div class="row">
    <wa-tabs />
    <div class="col-12 col-lg-9 c">
      <!-- the token opens the whole WhatsApp account: the school account and '*' supervisors only -->
      <div class="card card-body text-center" v-if="!allowed">
        <i class="fa fa-lock wa-big text-muted"></i>
        <h5 class="g">هذه الصفحة لحساب المدرسة ومن لديه كامل الصلاحيات</h5>
      </div>

      <template v-else>
        <div class="text-center g" v-if="loading">
          <img :src="require('@/assets/images/loading.svg')" style="width: 80px; height: 80px" alt="جاري التحميل" />
        </div>
        <div class="alert alert-danger text-center g" v-if="error">
          {{ error }}
          <router-link v-if="notLinked" to="/_whatsapp" class="wa-link">فحص الجهاز</router-link>
        </div>

        <div class="card" v-if="!loading && !error">
          <div class="card-header">
            <h5 class="m-0"><i class="fa fa-code"></i> الربط البرمجي (API)</h5>
          </div>
          <div class="card-body">
            <div class="alert alert-warning">
              <i class="fa fa-exclamation-triangle"></i>
              هذا الرمز يعطي تحكماً كاملاً في حساب الواتساب الخاص بالمدرسة (الإرسال والأرشيف والأجهزة). لا تشاركه إلا مع مبرمج موثوق، ولا تضعه في صفحة يراها الآخرون.
            </div>

            <div class="form-group">
              <label for="wa-token"><strong>رمز الوصول (JWT)</strong></label>
              <div class="wa-copy-row">
                <input id="wa-token" :type="showToken ? 'text' : 'password'" class="form-control wa-ltr" :value="info.jwt" readonly dir="ltr" autocomplete="off" style="direction: ltr; text-align: left" />
                <button class="btn btn-outline-secondary" @click="showToken = !showToken">
                  <i :class="'fa ' + (showToken ? 'fa-eye-slash' : 'fa-eye')"></i> {{ showToken ? 'إخفاء' : 'إظهار' }}
                </button>
                <button class="btn btn-primary" @click="copy(info.jwt, 'token')">
                  <i class="fa fa-copy"></i> {{ copied == 'token' ? 'تم النسخ' : 'نسخ' }}
                </button>
              </div>
            </div>

            <div class="form-group">
              <label for="wa-base"><strong>رابط الخدمة</strong></label>
              <div class="wa-copy-row">
                <input id="wa-base" type="text" class="form-control wa-ltr" :value="info.base" readonly dir="ltr" style="direction: ltr; text-align: left" />
                <button class="btn btn-outline-primary" @click="copy(info.base, 'base')">
                  <i class="fa fa-copy"></i> {{ copied == 'base' ? 'تم النسخ' : 'نسخ' }}
                </button>
              </div>
              <small class="text-muted">
                التوثيق الكامل:
                <a :href="info.docs" target="_blank" rel="noopener">صفحة توثيق الـ API</a>
              </small>
            </div>

            <h6 class="g"><strong>الأجهزة (device_id)</strong></h6>
            <div class="text-muted g" v-if="!info.devices.length">لا يوجد جهاز مرتبط بعد.</div>
            <div class="table-responsive wa-dev-table" v-else>
              <table class="table table-sm table-bordered">
                <thead>
                  <tr>
                    <th>الجهاز</th>
                    <th>device_id</th>
                    <th>الجوال</th>
                    <th>الحالة</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="d in info.devices" :key="d.id">
                    <td>{{ d.title }}</td>
                    <td class="wa-nowrap">
                      <bdi dir="ltr" class="wa-code">{{ d.id }}</bdi>
                      <button class="btn btn-link btn-sm p-0 wa-mini" @click="copy(d.id, 'id' + d.id)">
                        {{ copied == 'id' + d.id ? 'تم النسخ' : 'نسخ' }}
                      </button>
                    </td>
                    <td class="wa-nowrap"><bdi dir="ltr">{{ d.phone || '—' }}</bdi></td>
                    <td>{{ d.status_text }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <small class="text-muted">عند الإرسال يمكن وضع رقم جوال الجهاز بدل device_id.</small>

            <h6 class="g mt-2"><strong>مثال: إرسال رسالة</strong></h6>
            <div class="wa-code-box">
              <button class="btn btn-sm btn-light wa-code-copy" @click="copy(curlSend, 'curl')">
                <i class="fa fa-copy"></i> {{ copied == 'curl' ? 'تم النسخ' : 'نسخ' }}
              </button>
              <pre dir="ltr" style="direction: ltr; text-align: left">{{ curlSend }}</pre>
            </div>
            <ul class="text-muted wa-notes">
              <li><code>numbers</code>: رقم أو أكثر مفصولة بفاصلة، بالصيغة الدولية مثل <bdi dir="ltr">9665XXXXXXXX</bdi>.</li>
              <li><code>file</code> (اختياري): رابط مرفق يُرسل مع الرسالة.</li>
              <li>الرد <bdi dir="ltr">{"status":100}</bdi> يعني أن الرسالة دخلت قائمة الإرسال، وتظهر حالتها في «أرشيف الرسائل».</li>
            </ul>

            <h6 class="g"><strong>مثال: أرشيف الرسائل</strong></h6>
            <div class="wa-code-box">
              <button class="btn btn-sm btn-light wa-code-copy" @click="copy(curlArchive, 'curl2')">
                <i class="fa fa-copy"></i> {{ copied == 'curl2' ? 'تم النسخ' : 'نسخ' }}
              </button>
              <pre dir="ltr" style="direction: ltr; text-align: left">{{ curlArchive }}</pre>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import WaTabs from './wa-tabs.vue';

export default {
  components: { WaTabs },
  data() {
    return {
      user: JSON.parse(localStorage.getItem('user')),
      allowed: checkPer('*'),
      info: { jwt: '', base: '', docs: '', devices: [] },
      loading: true,
      error: null,
      notLinked: false,
      showToken: false,
      copied: null,
    };
  },
  computed: {
    // examples show the placeholder, never the real token (it is copied from the field above)
    curlSend() {
      var dev = this.info.devices[0]?.id || 'DEVICE_ID';
      return 'curl -X POST "' + this.info.base + '/user/messages/send" \\\n' +
        '  -H "Content-Type: application/json" \\\n' +
        "  -d '{\n" +
        '    "jwt": "YOUR_JWT",\n' +
        '    "devices": "' + dev + '",\n' +
        '    "numbers": "966500000000,966511111111",\n' +
        '    "message": "مرحباً، هذه رسالة تجريبية"\n' +
        "  }'";
    },
    curlArchive() {
      return 'curl -X POST "' + this.info.base + '/user/messages/api/archive" \\\n' +
        '  -H "Content-Type: application/json" \\\n' +
        "  -d '{\"jwt\": \"YOUR_JWT\", \"page\": 1, \"status\": \"all\"}'";
    },
  },
  created() {
    if (!checkPer('whatsapp')) {
      this.$router.push('/NotPermitted');
      return false;
    }
    if (!this.allowed) {
      this.loading = false;
      return;
    }
    var g = this;
    $.post(api + '/user/whatsapp/api-info', { jwt: g.user.jwt })
      .then(function (r) {
        g.loading = false;
        if (r.status != 100) {
          g.error = r.response;
          g.notLinked = !!r.not_linked;
          return;
        }
        g.info = r.response;
      })
      .fail(function () {
        g.loading = false;
        g.error = 'تعذر الاتصال بالخادم، تحقق من الإنترنت';
      });
  },
  methods: {
    copy(text, key) {
      var g = this;
      function mark() {
        g.copied = key;
        setTimeout(function () {
          if (g.copied == key) g.copied = null;
        }, 1800);
      }
      try {
        navigator.clipboard.writeText(text).then(mark, function () {
          g.fallbackCopy(text);
          mark();
        });
      } catch (e) {
        g.fallbackCopy(text);
        mark();
      }
    },
    fallbackCopy(text) {
      var t = document.createElement('textarea');
      t.value = text;
      t.setAttribute('readonly', '');
      t.style.position = 'fixed';
      t.style.opacity = '0';
      document.body.appendChild(t);
      t.select();
      try {
        document.execCommand('copy');
      } catch (e) {}
      document.body.removeChild(t);
    },
  },
};
</script>

<style scoped>
.wa-big {
  font-size: 48px;
}
.wa-link {
  margin-inline-start: 8px;
  font-weight: 600;
}
.wa-copy-row {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}
.wa-copy-row .form-control {
  flex: 1 1 260px;
  min-width: 0;
}
/* direction / text-align are inline: postcss-rtl would flip them here */
.wa-ltr {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 13px;
}
.wa-nowrap {
  white-space: nowrap;
}
.wa-code {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 12.5px;
}
.wa-mini {
  margin-inline-start: 6px;
  font-size: 12px;
}
.wa-code-box {
  position: relative;
  border-radius: 10px;
  background: #0f172a;
  color: #e2e8f0;
  overflow-x: auto;
}
.wa-code-box pre {
  margin: 0;
  padding: 14px 16px;
  padding-top: 40px;
  color: inherit;
  background: transparent;
  font-size: 12.5px;
  white-space: pre;
}
.wa-dev-table {
  min-height: 0;
  margin-bottom: 4px;
}
.wa-code-copy {
  position: absolute;
  top: 6px;
  inset-inline-end: 6px;
}
.wa-notes {
  font-size: 13px;
  margin-top: 8px;
  padding-inline-start: 18px;
}
</style>
